
import { mapGetters } from 'vuex';

import { defineComponent } from '@vue/composition-api';
import position from '../components/Position.vue';

export default defineComponent({
  name: 'Company',
  components: {
    position,
  },
  data() {
    return {
      loaded: false,
      search: '',
      compPositions: [] as any[],
    };
  },
  async mounted() {
    let data = await this.$store.dispatch('getCompanyPositions', {
      companyID: this.$route.params.id,
      includeItemData: true,
    });
    this.loaded = true;
    // TODO: cleanup
    // if (!data?.length) {
    //   let { data: compData } = await this.$store.dispatch(
    //     "getManualJobs",
    //     this.$route.params.id
    //   );
    //   data = compData;
    // }
    // if (!data?.length) {
    //   const { data: compData }: any = await this.$store.state.db
    //     .collection("jobs")
    //     .query("company.itemRefID", "=", this.$route.params.id)
    //     .get();

    //   data = compData;
    // }
    // TODO: cleanup
    // if (!data?.length) {
    //   data = await this.getPositions();
    // }

    data = data?.filter((c) => c.manualJob || c.active).length ? data : [];

    this.compPositions = data;
  },
  methods: {
    linkify(url: string) {
      if (url.match(/\/\//)) return url;
      return `//${url}`;
    },
  },
  computed: {
    ...mapGetters(['typeByID', 'locationByID', 'comps']),
    jobCount(): boolean | number {
      return this.compPositions.length;
    },
    company(): any {
      return this.comps.find((company) => company._id == this.$route.params.id);
    },
    companyType(): any {
      return this.typeByID(this.company.companyType._id);
    },
  },
});
